import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA1nHhdWJTRoitUDS4Qqa0nQgSGEphaDZg",
  authDomain: "ci-website-23.firebaseapp.com",
  projectId: "ci-website-23",
  storageBucket: "ci-website-23.appspot.com",
  messagingSenderId: "1015496156359",
  appId: "1:1015496156359:web:19ed90a1bfa6ace4698ae2",
  measurementId: "G-XM3WKFWZ5P",
};

const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);

export { firestore };
